// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .body {
     background-color: #333;
     display: flex;
     justify-content: center;
     align-items: center;
     height: 100vh;
 }

 .rainbowText {
     font-family: arial black;
     font-size: 70px;
     background-image:
         linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet);
     -webkit-background-clip: text;
     -webkit-text-fill-color: transparent;
     animation: move 100s linear infinite;
 }

 @keyframes move {
     to {
         background-position: 4500vh;
     }
 }`, "",{"version":3,"sources":["webpack://./src/component/common/tile/Easter.css"],"names":[],"mappings":"CAAC;KACI,sBAAsB;KACtB,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,aAAa;CACjB;;CAEA;KACI,wBAAwB;KACxB,eAAe;KACf;oFAC+E;KAC/E,6BAA6B;KAC7B,oCAAoC;KACpC,oCAAoC;CACxC;;CAEA;KACI;SACI,2BAA2B;KAC/B;CACJ","sourcesContent":[" .body {\n     background-color: #333;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     height: 100vh;\n }\n\n .rainbowText {\n     font-family: arial black;\n     font-size: 70px;\n     background-image:\n         linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet);\n     -webkit-background-clip: text;\n     -webkit-text-fill-color: transparent;\n     animation: move 100s linear infinite;\n }\n\n @keyframes move {\n     to {\n         background-position: 4500vh;\n     }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
